import { IconFolderDown } from "@tabler/icons-react";
import { Button } from "@mantine/core";
import { Link } from "react-router-dom";
import { useConfigContext } from "../../../../contexts/ConfigContext/ConfigContextProvider";

export default function DownloadClassInfoCard() {

   const { jsonTexts } = useConfigContext()
   const texts = jsonTexts?.lessonView?.lessonDetailsCards?.materialClassInfoCard

  return (
    <article className="ClassDetails-card-container">
      <div className="ClassDetails-card--row">
        <IconFolderDown size={50} color="var(--color-tertiary)" />
      </div>
      <div className="ClassDetails-card--row">
        <h5 className="ClassDetails-card-headline">
          {texts?.title}
        </h5>
      </div>
      <div className="ClassDetails-card--row">
        <p className="ClassDetails-card-text">
          {texts?.description}
        </p>
      </div>

      <Button m="auto" w="90%" component={Link} to={"material"}>
        {texts?.buttonText}
      </Button>
    </article>
  );
}
